import BookItem from "../common/bookItem";
export default class VisibleSwitchAnsStepAllGroup extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.ctrlOrder = 0;

        /**
         * 連結按鈕，目前沒用到
         */
        this.connectNumber = this.el.connectNumber;

        this.add_mouse_event();
        this.target.gotoAndStop(0);

        /**
         * 全部解答主按鈕
         */
        this.childGroup01 = [];

        /**
         * 全部解答子按鈕暫存處理
         */
        this.childGroup01_childTemp = [];

        /**
         * 全部解答子按鈕(獨立)
         */
        this.childGroup01_child = [];

        /**
         * 逐步解答主按鈕
         */
        this.childGroup02 = [];

        /**
         * 全頁解答子按鈕
         */
        this.childGroup03 = [];

        this.isInitButton = false;

    }

    init() {
        this.initGroups();
    }

    initGroups() {
        // console.log("======initLate======");

        if (this.connectNumber != "") {
            // 全部解答
            this.childGroup01 = this.itemControl.getItemsByClassGroupConnect("ansshowbtn", this);

            // 全部解答子按鈕(獨立)
            this.childGroup01_childTemp = this.itemControl.getItemsByClassGroupConnect("ansshowbtnchild", this);

            // 逐步解答
            this.childGroup02 = this.itemControl.getItemsByClassGroupConnect("stepallbtn", this);

            // 全頁解答子物件
            this.childGroup03 = this.itemControl.getItemsByClassGroupConnect("visibleSwitchAnsStepAllGroupChild", this);
        }
        else {
            // 全部解答
            this.childGroup01 = this.itemControl.getItemsByClassPageId("ansshowbtn", this);

            // 全部解答子按鈕(獨立)
            this.childGroup01_childTemp = this.itemControl.getItemsByClassPageId("ansshowbtnchild", this);

            // 逐步解答
            this.childGroup02 = this.itemControl.getItemsByClassPageId("stepallbtn", this);

            // 全頁解答子物件
            this.childGroup03 = this.itemControl.getItemsByClassPageId("visibleSwitchAnsStepAllGroupChild", this);
        }

        this.childGroup01.forEach(element => {
            element.mainGroup.push(this);
            element.childGroup.forEach(child => {
                child.mainGroup.push(this);
            });
        });
        // console.log("this.childGroup01", this.childGroup01);

        this.childGroup01_childTemp.forEach(element => {
            if (element.mainGroup.length == 0) {
                this.childGroup01_child.push(element);
                element.mainGroup.push(this);
            }
        });
        // console.log("this.childGroup01_child", this.childGroup01_child);

        this.childGroup02.forEach(element => {
            element.mainGroup.push(this);
            element.childGroup.forEach(child => {
                child.mainGroup.push(this);
            });
        });
        // console.log("this.childGroup02", this.childGroup02);

        this.childGroup03.forEach(element => {
            element.mainGroup.push(this);
        });
    }

    trigger() {
        // console.log("this check", this.isOpen);
        const self = this;
        this.isOpen = !this.isOpen;
        // console.log("this.isOpen", this.isOpen);

        // if (!this.isInitButton) {
        //     this.isInitButton = true;
        //     this.initGroups();
        // }

        if (self.isOpen) {
            // console.log("gotoAndStop(1)");
            self.target.gotoAndStop(1);

            this.childGroup03.forEach(element => {
                element.target.gotoAndStop(1);
                element.isOpen = true;
            });
        }
        else {
            // console.log("gotoAndStop(0)");
            self.target.gotoAndStop(0);

            this.childGroup03.forEach(element => {
                element.target.gotoAndStop(0);
                element.isOpen = false;
            });
        }

        // 打開狀態
        this.childGroup01.forEach(element => {
            element.ControlTrigger(this.isOpen);
        });

        this.childGroup01_child.forEach(element => {
            element.ControlTrigger(this.isOpen);
        });

        this.childGroup02.forEach(element => {
            element.ControlTrigger(this.isOpen);
        });

        this.TestCheck();
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
        });
    }

    /**
     * 主按鈕檢查群子按鈕
     */
    TestCheck() {
        // console.log("Testcheck", this);
        let allOpenSucess = true;
        // 檢查全部底下子物件，有沒開的就 allOpenSucess = false;
        this.childGroup01.forEach(element => {
            if (element.isOpen == false) {
                allOpenSucess = false;
                this.isOpen = false;
                this.target.gotoAndStop(0);
                return;
            }
        });

        this.childGroup01_child.forEach(element => {
            if (element.isOpen == false) {
                // console.log("element.isOpen!!!", element.isOpen);
                allOpenSucess = false;
                this.isOpen = false;
                this.target.gotoAndStop(0);
                return;
            }
        });

        this.childGroup02.forEach(element => {
            if (element.childObj.isOpen == false) {
                allOpenSucess = false;
                this.isOpen = false;
                this.target.gotoAndStop(0);
                return;
            }
        });

        this.childGroup03.forEach(element => {
            if (element.isOpen == false) {
                allOpenSucess = false;
                this.isOpen = false;
                this.target.gotoAndStop(0);
                return;
            }
        });

        // 有全開，物件做子物件全開時要做的事
        if (allOpenSucess) {
            this.isOpen = true;
            this.target.gotoAndStop(1);
        }
    }
}